module.exports = __webpack_public_path__ + "img/logo.086c369d.png";